<template>
  <portlet
      :title="$t('shopfloor.trackAndTrace.history')"
      :icon="'fad fa-map-signs'"
      class="mb-3"
  >
    <template slot="portletBody">
      <div v-if="product">
        <b>{{ $t('shopfloor.trackAndTrace.productNumber') }}: </b>{{ product.productNumber }}<br/>
        <b>{{ $t('shopfloor.trackAndTrace.productName') }}: </b>{{ product.name }}<br/><br/>
        <TimeLine v-if="events.length" :events="events"></TimeLine>
        <p v-else>{{ $t('shopfloor.trackAndTrace.noEvents') }}</p>
      </div>
      <div v-else>
        {{ $t('shopfloor.trackAndTrace.loadingEvents') }}
      </div>
    </template>
  </portlet>
</template>

<script>
import TimeLine from '../../components/timeline/TimeLine';
export default {
  name: "TrackAndTrace",
  data() {
    return {
      product: null,
      events: []
    };
  },
  components: { TimeLine },
  methods: {
    async checkBarcode(barcode) {
      this.$store.commit('setLoading', true)
      let token = JSON.parse(localStorage.getItem('motivate-token')).oauthToken;
      try {
        const res = await this.$CLOUD_API.get(`/trackandtrace/${barcode}`, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        this.product = res.data.product;
        this.events = _.orderBy(res.data.events, event => { return new Date(event.eventTimeStamp)});
        this.$store.commit('setLoading', false)
      } catch (e) {
        console.error(e);
        this.$store.commit('setLoading', false)
        this.$router.back();
      }
    },
  },
  created() {
    this.checkBarcode(this.$route.params.productNumber);
  }
}
</script>

<style scoped lang="scss">
.product {
  display: grid;
  grid-template-columns: 8rem auto;
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 12px;
  grid-row-gap: 12px;
}
</style>
